<template>
	<div class="list-registrations">
		<div class="list-registrations__heading">
		</div>

		<table-list
			:items="registrations"
			:loading="loading"
		>
			<template slot="header">
				<span
					:class="`registrations-header-item registrations-header-item--${key}`"
					:key="key"
					v-for="(col, key) in columns"
				>
					<component :is="orderBy[key] ? 'a' : 'span'" @click="sort(key)"> {{ col }}</component>
					<ion-icon :name="query.order == 'asc' ? `caret-up` : `caret-down`" v-if="orderBy[key] && orderBy[key] == query.orderBy"></ion-icon>
				</span>
			</template>

			<template slot="item" slot-scope="{ item }">
				<router-link
					:class="`registrations-item registrations-item--${key} registrations-item--${item['status']}`"
					:key="`item_${key}`"
					:to="{ name: 'registration', params: { regId: item.regId } }"
					v-for="(col, key) in columns"
					v-html="transform(key, get(item, key))"
				>
				</router-link>
			</template>
		</table-list>
	</div>
</template>

<script>
import { format, parseISO, formatDistanceToNowStrict } from 'date-fns'
import { get } from 'lodash'
import { RegistrationStatus } from '@/lib/enums'

import TableList from '@/components/TableList'

export default {
	name: 'ListRegistrations',
	components: {
		TableList,
	},
	props: {
		loading: Boolean,
		registrations: {
			type: Array,
			default: () => ([]),
		},
	},
	data: () => ({
		columns: {
			profileName: 'Name',
			email: 'Email',
			organization: 'Organization',
			phone: 'Phone',
			dateCreated: 'Registered',
			status: 'Status',
		},
		order: 'asc',
	}),
	computed: {
		orderBy() {
			let orderBy = {
				profileName: 'name',
				email: 'email',
				organization: 'organization.name',
				dateCreated: 'dateCreated',
				status: 'status',
			}

			return orderBy
		},
		query() {
			return this.$route.query
		},
	},
	methods: {
		sort(key) {
			if (this.orderBy[key]) {
				const query = {
					...this.$route.query,
					orderBy: this.orderBy[key],
					order: this.$route.query.order == 'asc' ? 'desc' : 'asc',
				}
				this.$router.push({ query })
			}
		},
		transform(key, value) {
			switch(key) {
				case 'organization':
					if (!value) return
					let toReturn = value.name
					if (value.address) {
						toReturn += '<br />'+ [value.address.city, value.address.state].join(', ')
					}
					return toReturn
				case 'dateCreated':
					try {
						const dt = parseISO(value)
						value = `<span title="${format(dt, 'Pp')}">${formatDistanceToNowStrict(dt, { addSuffix: true})}</span>`
					} catch (error) {
						console.warn(error)
					}
					return value
				case 'status':
					return RegistrationStatus[value]
					return
				default:
					break
			}

			return value
		},
		get,
	},
}
</script>

<style scoped lang="scss">
.list-registrations {
	&__heading {
		@include modules.gutter('padding-left');
		@include modules.gutter('padding-right');
	}

	::v-deep .table-list {
		&__item,
		&__header {
			border-bottom: 1px solid modules.color_('background', 'medium');
			display: grid;
			grid-template-columns: minmax(100px, 1fr) minmax(100px, 1.5fr) repeat(3, minmax(100px, 1fr)) minmax(100px, auto);

			@include modules.media-query('phone') {
				grid-template-columns: minmax(50%, 1fr) minmax(50%, 1fr);
			}
		}
	}

	.registrations-header-item {
		@include modules.fontSize(14px);
		font-weight: 600;
		padding: 1em 1.5em;

		@include modules.media-query('phone') {
			padding: 0.5em 1em;
		}
	}

	.registrations-item {
		color: modules.color_('text', 'dark');
		font-weight: 500;
		overflow-wrap: break-word;
		padding: 1.5em;
		text-decoration: none;

		@include modules.media-query('phone') {
			@include modules.fontSize(15px);
			padding: 0.5em 1em;
		}

		&--pending {
			&.registrations-item--status {
				color: modules.color_('announce', 'text');
			}
		}

		&--removed {
			opacity: 0.7;

			&.registrations-item--status {
				color: modules.color_('alert', 'critical')
			}
		}
	}
}
</style>
